// sendQuestionnaireLogic.ts
import { Ref, ref } from "vue";
import { Participant, ParticipantActivityType, Project, Trainer } from "../../types/PersologOnlineTypes.ts";
import { ProfileAdministrationAPI } from "../../api";
import { sendQuestionnaireEmail } from "../EmailUtils.ts";
import { activateParticipant } from "../ProjectUtils.ts";

export async function sendReminderToParticipant(trainer: Trainer, participant: Participant, project: Project) {
    await sendQuestionnaireEmail(trainer, participant, project);
    await ProfileAdministrationAPI.logParticipantActivity(
        participant.id!,
        ParticipantActivityType.REMINDER_MAIL_SENT,
    );
}

export async function sendActivationEmail(trainer: Trainer, participant: Participant, project: Project) {
    await sendQuestionnaireEmail(trainer, participant, project);
    await ProfileAdministrationAPI.logParticipantActivity(
        participant.id!,
        ParticipantActivityType.QUESTIONNAIRE_MAIL_SENT,
    );
}

export default function useQuestionnaireSend(participant: Ref<Participant>, project: Ref<Project>, trainer: Trainer) {
    const loading = ref(false);

    const activatedParticipant = ref<Participant | null>(null);

    async function activateOrRemind() {
        loading.value = true;
        try {
            if (participant.value.status === "CREATED" || participant.value.status === "REVOKED") {
                activatedParticipant.value = await activateParticipant(project.value, participant.value, trainer);
                return activatedParticipant.value;
            } else {
                await sendReminderToParticipant(trainer, participant.value, project.value);
                return null;
            }
        } finally {
            loading.value = false;
        }
    }

    return {
        loading,
        activateOrRemind,
        activatedParticipant,
    };
}
